const ORGNAME_STORAGE_KEY = "orgname";
const LEGACY_FALLBACK_ORGNAME = "org936a573b";

// Tactical host fallback for the sales deployment until every launch URL carries orgname.
const HOST_ENV_MAP: Record<string, string> = {
    "rostering-sales.avant.care": "unq592468f5caa7ef118a67002248e34",
};

const normalizeOrgName = (value?: string | null): string => String(value ?? "").trim();

export const getQueryOrgName = (): string => {
    return normalizeOrgName(new URLSearchParams(window.location.search).get("orgname"));
};

export const resolveAvantCareEnvHeader = (): string => {
    const fromQuery = getQueryOrgName();
    if (fromQuery) {
        return fromQuery;
    }

    const fromStorage = normalizeOrgName(localStorage.getItem(ORGNAME_STORAGE_KEY));
    if (fromStorage) {
        return fromStorage;
    }

    const fromBuild = normalizeOrgName(process.env.REACT_APP_DEFAULT_ORGNAME);
    if (fromBuild) {
        return fromBuild;
    }

    const fromHost = HOST_ENV_MAP[window.location.hostname.toLowerCase()];
    if (fromHost) {
        return fromHost;
    }

    return LEGACY_FALLBACK_ORGNAME;
};

export const bootstrapAvantCareEnvHeader = (): string => {
    const resolved = resolveAvantCareEnvHeader();
    if (resolved) {
        localStorage.setItem(ORGNAME_STORAGE_KEY, resolved);
    }
    return resolved;
};
